import axios from "axios";
export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    //delete a user
    async updateUser({ getters }, payload) {
      const token = getters.getCognitoJwtToken;
      payload.token = token;

      try {
        const response = await axios.put(`/api/users/${payload.userId}`, {
          headers: { "Content-Type": "application/json" },
          data: { ...payload },
        });
        return response;
      } catch (error) {
        console.log("error updating user....", error);
      }
    },
    //delete a user
    async deleteUser({ getters }, { userId }) {
      const token = getters.getCognitoJwtToken;
      try {
        const response = await axios.delete(`/api/users/${userId}`, {
          data: { token },
        });
        return response;
      } catch (error) {
        console.log("error deleteing user....", error);
      }
    },

    //get all users
    async getAllUsers({ getters }) {
      const params = { token: getters.getCognitoJwtToken };
      try {
        const response = await axios.get(`/api/users`, { params });
        return response;
      } catch (error) {
        console.log("error while fetching users....", error);
      }
    },
    // Create User - Congnito and DB
    async createUser({ getters }, payload) {
      const formData = submitData(payload, getters);
      try {
        const response = await axios.post(`/api/users/create`, formData);
        return response;
      } catch (error) {
        if (error.response.status === 419) {
          this.dispatch("logout");
        } else {
          return error;
        }
      }
    },
    // User Player Tracking
    async updatePlayerTracker({ getters }, payload) {
      const filterOptions = submitData(payload.filterOptions, getters);
      try {
        const response = await axios.post(
          `/api/${payload.report}/${payload.dataset}`,
          filterOptions
        );
        return response;
      } catch (error) {
        if (error.response.status === 419) {
          this.dispatch("logout");
        } else {
          console.log(error);
        }
      }
    },
    // User Player Tracking
    async addPlayerToPlayerTracker({ getters }, payload) {
      const filterOptions = setFilterOptionsOperatorAndNetworkId(
        payload.filterOptions,
        getters
      );
      try {
        const response = await axios.post(
          `/api/${payload.report}/${payload.dataset}`,
          filterOptions
        );
        return response;
      } catch (error) {
        if (error.response.status === 419) {
          this.dispatch("logout");
        } else {
          console.log(error);
        }
      }
    },
  },
};

function setFilterOptionsOperatorAndNetworkId(filterOptions, getters) {
  // If user has an operator ID, always use that as this means user should only ever see data for that operator.
  if (
    getters.getUserOperatorId ||
    !("operatorId" in filterOptions && filterOptions.operatorId)
  ) {
    filterOptions.operatorId = getters.getUserOperatorId;
  }

  // If user has an network ID, always use that as this means user should only ever see data for that network.
  if (
    getters.getUserNetworkId ||
    !("networkId" in filterOptions && filterOptions.networkId)
  ) {
    filterOptions.networkId = getters.getUserNetworkId;
  }

  // Set the user User Id.
  if (getters.getUserId) {
    filterOptions.userId = getters.getUserId;
  }

  // Finally, add JWT token for validation in API.
  filterOptions.token = getters.getCognitoJwtToken;

  return filterOptions;
}

function submitData(filterOptions, getters) {
  // Set the user User Id.
  if (getters.getUserId) {
    filterOptions.userId = getters.getUserId;
  }
  // Finally, add JWT token for validation in API.
  filterOptions.token = getters.getCognitoJwtToken;
  return filterOptions;
}
